import React from "react";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import { TurnrButton } from "~/components/buttons/TurnrButton";
import { TurnrFontAwesomeIcon } from "~/components/buttons/icon-buttons/TurnrFontAwesomeIconButton";
import { isInputValueChanged } from "~/utils";
import { COLORS } from "rylak-common/src/constants";

export default function SettingCategoryButton(props) {
    const { onClick, settingsCategory, reverseIcons, detectChangeValues, error } = props;
    const changes = detectChangeValues?.find((v) => isInputValueChanged(v.originalValue, v.value));
    return (
        <TurnrGrid item xs={12}>
            <TurnrButton
                color={error ? COLORS.ERROR : changes && COLORS.CHANGES}
                size={"large"}
                style={{ borderRadius: "3px" }}
                runningLine={false}
                onClick={() => onClick(settingsCategory?.id)}
                variant={"text"}
                fullWidth={true}
                textStyle={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <div
                    style={{
                        marginLeft: "-10px",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <TurnrFontAwesomeIcon icon={reverseIcons ? faAngleLeft : settingsCategory?.icon} size={"large"} />
                    <span style={{ marginLeft: "10px" }}>{settingsCategory?.title}</span>
                </div>
                <div style={{ marginRight: "-10px" }}>
                    <TurnrFontAwesomeIcon icon={reverseIcons ? settingsCategory?.icon : faAngleRight} size={"large"} />
                </div>
            </TurnrButton>
        </TurnrGrid>
    );
}
